import type {ReactElement} from 'react';

import type {SelectProps} from '@/components/common/Input';
import {Select} from '@/components/common/Input';
import {AfriexCurrencyCode} from '@/types';

import {mapOptionsToList} from './utils';
interface CurrencyPickersProps extends Omit<SelectProps, 'options'> {
  options?: {key: string; value: string}[];
}

const CurrencyPicker = (props: CurrencyPickersProps): ReactElement => {
  const options = mapOptionsToList(Object.values(AfriexCurrencyCode));
  return <Select {...props} options={options} />;
};
export default CurrencyPicker;
